import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Badge } from '@wit-support/ui';
import { CONTENT_NETWORK_LABEL_RU } from './content-labels.js';
import { cn } from './lib/cn.js';
import { contentNetworkColorToken } from './tokens/content.js';
/**
 * Чип сети контента: цвет сети (`--color-network-<net>-{bg,fg,solid}`) +
 * имя. Цвет никогда не единственный носитель смысла — имя всегда есть
 * (текстом или в `aria-label`). Токены подставляются inline (как в
 * `ChannelBadge`): Tailwind не может перечислить их заранее.
 */
export const NetworkChip = React.forwardRef(({ network, size = 'sm', children, dotOnly = false, className }, ref) => {
    const label = CONTENT_NETWORK_LABEL_RU[network];
    const dot = (_jsx("span", { "aria-hidden": true, className: "inline-block h-2 w-2 shrink-0 rounded-full", style: { backgroundColor: `var(${contentNetworkColorToken(network, 'solid')})` } }));
    if (dotOnly) {
        return (_jsx("span", { ref: ref, role: "img", "aria-label": label, title: label, className: cn('inline-flex items-center', className), children: dot }));
    }
    return (_jsxs(Badge, { ref: ref, size: size, variant: "neutral", "data-network": network, className: cn('border-transparent whitespace-nowrap', className), style: {
            backgroundColor: `var(${contentNetworkColorToken(network, 'bg')})`,
            color: `var(${contentNetworkColorToken(network, 'fg')})`,
        }, children: [dot, _jsx("span", { children: label }), children != null ? _jsx("span", { className: "font-semibold tabular-nums", children: children }) : null] }));
});
NetworkChip.displayName = 'NetworkChip';
//# sourceMappingURL=content-network-chip.js.map